export default __webpack_public_path__ + "static/media/Medicine.3772d4c5.svg";